
import React from 'react';
import { Link } from 'react-router-dom';
// import MobileImg from '../../assets/images/Home/MobileImg.webp'

const TimingsandMobile = () => {
  return (
    <>
    <div className='container-fluid bg-middle-banner p-5' id="website-responsive">
		<div className='row justify-content-center text-white text-raleway pb-4 mt-md-5'>
			{/* Desktop */}
			<div className='col-md-8 text-center'>
				<h3 className='fs-zk-52 fw-700'>
				Not just better healthcare, but a better healthcare experience
				</h3>
			</div>
			{/* Mobile */}
			{/* <div className='d-block d-lg-none col-11 text-center'>
				<h3 className='fs-zk-32 fw-700'>
				Not just better healthcare, but a better healthcare experience
				</h3>
			</div> */}
			</div>
			<div className='row justify-content-center text-center gy-4 text-poppins mb-md-5'>
				<div className='col-11 col-lg-4 text-lg-end'>
					<Link to="/book-an-appointment" className='fw-500 fs-zk-20 border-0 px-4 py-2 rounded-0 btn btn-zk-secondary text-capitalize text-white'>
						Book Appointment
					</Link>
				</div>
				<div className='col-11 col-lg-4 text-lg-start'>
					<a href="tel:+12562591234" className='text-decoration-none fw-500 fs-zk-20 border-0 px-4 py-2 btn rounded-0 btn-zk-secondary text-capitalize text-white'>
					256-259-1234
					</a>
				</div>
			</div>
    </div>
    </>
  );
}

export default TimingsandMobile;
